import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';

/* import modules */
import { CoreModule } from './core/core.module';
import { HomeModule } from './home/home.module';
import { NgZorroAntdModule, NZ_LOCALE, zhCN } from 'ng-zorro-antd';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

@NgModule({
    imports: [
        BrowserModule,
        // BrowserAnimationsModule,
        NoopAnimationsModule,
        CoreModule.forRoot(),
        // NgZorroAntdModule.forRoot(),
        NgZorroAntdModule.forRoot({ extraFontName: 'anticon', extraFontUrl: './assets/fonts/iconfont' }),
        HomeModule,
        AppRoutingModule
    ],
    providers: [{ provide: NZ_LOCALE, useValue: zhCN }],
    declarations: [AppComponent],
    bootstrap: [AppComponent]
})
export class AppModule {
    // constructor(
    //     private router: Router
    // ) {
    //     console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
    // }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/app.module.ts